import React, { useEffect, useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ActionBarMaybe from './ActionBarMaybe';
import ListingImgSwiper from './ListingImgSwiper';
import { isNegotiationProcess } from '../../transactions/transaction';
import css from './ListingPage.module.css';

const SectionHero = props => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    title,
    listing,
    isOwnListing,
    editParams,
    currentUser,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    noPayoutDetailsSetWithOwnListing,
  } = props;

  const hasImages = listing.images && listing.images.length > 0;
  const allImages = listing.images;
  const firstImage = hasImages ? listing.images[0] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];
   const processName = listing?.attributes?.publicData?.transactionProcessAlias;
  const isNegotiation = isNegotiationProcess(processName);
  const viewPhotosButton = hasImages && listing.images.length > 1 ? (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length }}
      />
    </button>
  ) : null;

  return (
    <section className={css.sectionHero} data-testid="hero">
     {!isNegotiation && (
  <div className={css.listingImgBox}>
    <ListingImgSwiper allImages={allImages} />
  </div>
)}
      <div style={{display: "none"}} className={allImages?.length > 1 ? `${css.listingImgBox}`: `${css.listingImgBoxWide}`}>
        {/*{mounted && listing.id && isOwnListing ? (
          <div onClick={e => e.stopPropagation()} className={css.actionBarContainerForHeroLayout}>
            {noPayoutDetailsSetWithOwnListing ? (
              <ActionBarMaybe
                className={css.actionBarForHeroLayout}
                isOwnListing={isOwnListing}
                listing={listing}
                showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
                currentUser={currentUser}
              />
            ) : null}

            <ActionBarMaybe
              className={css.actionBarForHeroLayout}
              isOwnListing={isOwnListing}
              listing={listing}
              editParams={editParams}
              currentUser={currentUser}
            />
          </div>
        ) : null}*/}
        {/*<div className={css.mainImg}>
          <div className={css.imageWrapperForSectionHero} onClick={handleViewPhotosClick}>
            <ResponsiveImage
              rootClassName={css.rootForImage}
              alt={title}
              image={firstImage}
              variants={variants}
            />
          </div>
        </div>
        <div className={css.imgSidePanel} >
          {allImages.slice(1, 5).map((images, index) => (
            <div className={css.imgThumbBox} key={index} onClick={handleViewPhotosClick}>
              <ResponsiveImage
                  rootClassName={css.rootForImage}
                  alt={`Image ${index + 1}`}
                  image={images}
                  variants={Object.keys(images?.attributes?.variants).filter(k => k.startsWith('scaled'))}
                />
            </div>
          ))}
        </div>
        {viewPhotosButton}*/}
      </div>
      {/*<Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={listing.images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>*/}
    </section>
  );
};

export default SectionHero;
